import { render, staticRenderFns } from "./faceDetection.vue?vue&type=template&id=278fc9bd&scoped=true"
import script from "./faceDetection.vue?vue&type=script&lang=ts"
export * from "./faceDetection.vue?vue&type=script&lang=ts"
import style0 from "./faceDetection.vue?vue&type=style&index=0&id=278fc9bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278fc9bd",
  null
  
)

export default component.exports